import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(promo)/promo/[name]/page.tsx");
